/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type BankAccountApiResourceAccountType = typeof BankAccountApiResourceAccountType[keyof typeof BankAccountApiResourceAccountType] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BankAccountApiResourceAccountType = {
  checking: 'checking',
  savings: 'savings',
} as const;
